var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconJbl(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-c62bbe5d-9c96-49e1-98e2-190cb6128094",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-3a55dc8e-036c-4670-84cb-3b09a0a7200a{fill:#fff;}.uuid-84bcb5a9-f890-454d-8b7e-88615b88b622{fill:#00875d;}.uuid-2051bd1e-10cb-4b2f-96ef-da3ee1e7fbf3{fill:#0d4d84;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-3a55dc8e-036c-4670-84cb-3b09a0a7200a",
    d: "m-.5-.5h513v513H-.5V-.5Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-ba95cc4f-961d-4191-b777-5be918d713ab"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-3169b865-fddc-472c-ba26-5a9ab2947356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-9cc8c483-4dc6-4ba6-aacd-33da86d97beb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-f5f6b728-da0e-487d-8e44-cca540844fb0",
    className: "uuid-2051bd1e-10cb-4b2f-96ef-da3ee1e7fbf3",
    d: "m72.69,288.61c-6.33,0-10.61-1.08-12.83-3.24-2.22-2.16-3.33-6.21-3.33-12.17v-13.53l15.3-2.91v19.59h29.79v-52.96h15.21v49.81c0,5.96-1.13,10.02-3.37,12.17-2.25,2.16-6.52,3.24-12.83,3.24h-27.94"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-eeb4cb8d-7f10-4098-8065-b5c8fb486163"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-095ad90e-e2ca-4f94-804f-47f7a74dee9b",
    className: "uuid-2051bd1e-10cb-4b2f-96ef-da3ee1e7fbf3",
    d: "m132.74,288.61l36.86-65.22h14.62l37.36,65.22h-17.01l-11.45-21.28-37.5,6.94-2.07,3.75-5.69,10.59h-15.1Zm29.16-26.03h28.55l-14.06-26.53-14.49,26.53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-d460b635-fd5a-440c-ab7e-7f2b9678f270"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-49703626-5153-4495-a049-b9ca165e1885",
    className: "uuid-2051bd1e-10cb-4b2f-96ef-da3ee1e7fbf3",
    d: "m242.57,288.61v-65.22h55.84c5.16,0,8.89,1.01,11.2,3.03,2.31,2.02,3.46,5.23,3.46,9.64v7.92c0,3.12-.96,5.61-2.89,7.48-1.93,1.87-4.7,3.03-8.31,3.48,3.74.49,6.64,1.83,8.68,4.02,2.04,2.19,3.05,5.02,3.05,8.53v8.35c0,4.32-1.59,7.53-4.77,9.63-3.18,2.1-8.01,3.15-14.49,3.15h-51.77Zm49.49-54.57h-34.55v15.48h34.55c2.63,0,4.45-.35,5.45-1.05,1.01-.69,1.51-1.9,1.51-3.62v-6.14c0-1.68-.5-2.88-1.51-3.59s-2.82-1.08-5.45-1.08m0,26.21h-34.55v16.64h34.55c2.91,0,4.87-.43,5.88-1.3,1.02-.87,1.52-2.4,1.52-4.58v-4.95c0-2.19-.51-3.7-1.52-4.55-1.02-.85-2.98-1.27-5.88-1.27"
  })), /*#__PURE__*/React.createElement("path", {
    id: "uuid-1cf5f91b-f369-4220-aa18-068745c45968",
    className: "uuid-2051bd1e-10cb-4b2f-96ef-da3ee1e7fbf3",
    d: "m358.06,288.61h-15.21v-65.22h15.21v65.22Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "uuid-eaae6b58-7327-4bfd-9538-1e4d9f0f02b0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-168b01e3-38ed-4db9-9aff-677cdfd0ef13",
    className: "uuid-2051bd1e-10cb-4b2f-96ef-da3ee1e7fbf3",
    d: "m391.33,288.61v-65.22h15.21v52.96h48.93v12.26h-64.14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "uuid-9aba6057-961c-4fd2-bff9-1e6d8eb5c724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-adc75f00-12c9-4335-b715-762df59fa3b0",
    className: "uuid-84bcb5a9-f890-454d-8b7e-88615b88b622",
    d: "m166.96,253.29l-13.42,24.72,95.23-24.69-81.81-.04"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJbl);
export default __webpack_public_path__ + "static/media/icon_jbl.42fb7e1ebc81285456eaf31d473be867.svg";
export { ForwardRef as ReactComponent };